


































import Vue from 'vue'
import SimpleLoader from '@/components/atoms/SimpleLoader.vue'
import PageTitle from '@/components/atoms/PageTitle.vue'
import ButtonWrap from '@/components/atoms/ButtonWrap.vue'
import RoundButton from '@/components/atoms/RoundButton.vue'
import Alert from '@/components/atoms/Alert.vue'
import ListItem from '@/components/molecules/ListItem.vue'

export default Vue.extend({
  name: 'CreateProfile',
  components: {
    SimpleLoader,
    PageTitle,
    ButtonWrap,
    RoundButton,
    ListItem,
    Alert
  },
  data() {
    return {
      name: '',
      screen_name: '',
      did_agree_privacy_policy_eula: false
    }
  },
  computed: {
    isPageLoading(): boolean {
      return this.$state.registration.isRegistrationLoading
    }
  },
  methods: {
    onSubmit() {
      this.$validator.validateAll('profileForm').then(async result => {
        if (result) {
          await this.$store.dispatch('registration/setFormData', {
            name: this.name,
            screen_name: this.screen_name,
            did_agree_privacy_policy_eula: this.did_agree_privacy_policy_eula
          })
          await this.$store.dispatch('registration/setFormData')
          await this.$store.dispatch('registration/postSignUp')
        }
      })
    }
  },
  mounted() {
    if (this.$state.registration.forms.email.length === 0) {
      this.$router.push('/top')
    }
  }
})
